module.exports = "/assets/data/aa3de27cbd5929cbde887e9f49471d47-AB42.data.json";